import React from 'react';
import styled from 'styled-components';
import { Box } from '@landr/maestro';
import { Link } from 'react-router-dom';
import { analytics } from 'utils/analytics';
import { RoutePaths } from 'types/enums';
import { Label, CommonCard } from 'types';
import Artwork from 'components/CommonUi/Artwork/Artwork';
import { CardTitleCentered } from 'components/CommonUi/Cards';
import {
    CtaGoal,
    CtaType,
    InteractionSource,
} from 'utils/analytics/AnalyticsV2Service.generated';
import { useToLocalizedPath } from 'hooks/useToLocalizedPath/useToLocalizedPath';

const CardContainer = styled(Box)``;

const CardArtworkLinkContainer = styled(Link)``;

const CardTitleLinkContainer = styled(Link)``;

export const LabelCard: CommonCard<Label> = ({ item }) => {
    const toLocalizedPath = useToLocalizedPath();
    const to = toLocalizedPath(`/${RoutePaths.Labels}/${item.slug}`);

    function onCardClick(): void {
        analytics.trackCTAClicked({
            ctaGoal: CtaGoal.ViewDetail,
            ctaType: CtaType.Card,
            interactionSource: InteractionSource.CardAction,
            ctaDestination: to,
            ctaText: `Labels - ${item.name}`,
        });
    }

    return (
        <CardContainer>
            <CardArtworkLinkContainer to={to} onClick={onCardClick}>
                <Artwork
                    alt={`${item.name} Logo`}
                    imageUrl={item?.artworkUrl ?? undefined}
                    isRounded={true}
                    fallbackName={item?.name ?? undefined}
                    imageSize={192}
                />
            </CardArtworkLinkContainer>
            <CardTitleCentered>
                <CardTitleLinkContainer to={to} onClick={onCardClick}>
                    {item.name}
                </CardTitleLinkContainer>
            </CardTitleCentered>
        </CardContainer>
    );
};
